<div class="loading-style"> 
    <img src="/assets/img/loading.gif" />
</div>